import { render } from "./DashboardCard.vue?vue&type=template&id=ac9d5bf6&scoped=true&ts=true"
import script from "./DashboardCard.vue?vue&type=script&lang=ts"
export * from "./DashboardCard.vue?vue&type=script&lang=ts"

import "./DashboardCard.vue?vue&type=style&index=0&id=ac9d5bf6&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac9d5bf6"]])

export default __exports__